import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join("; ");
  return e?.message || "Request failed";
};

export const useReference = () =>
  useQuery({ queryKey: ["reference"], queryFn: () => get("/reference"), staleTime: Infinity });

export const useInvalidate = () => {
  const qc = useQueryClient();
  return (...keys) => keys.forEach((k) => qc.invalidateQueries({ queryKey: k }));
};
